import React from 'react';

import KeepwellMark from '../../img/IBEC-KeepWell-Mark-image.png';
import Logo from '../../img/asiera-logo-white.png';

export default function Footer({}) {
    return <footer>
        <div className="footer_top">&nbsp;</div>
        <div className="page-content page-content-footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-4">
                        <div className="footer_logo">
                            <a href="https://www.asiera.ie"><img src={Logo} /></a>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4">
                        <div className="footer_inner_1">
                            <p>Telephone: <a href="tel:+353-1-660 90 40">+353-1-660 90 40</a><br />
                                General Info: <a href="mailto:info@asiera.ie">info@asiera.ie</a></p>
                            <p>Registered in Ireland, No. 275301<br />
                                CHY No. 12414<br />
                                CRA No. 20036270</p>
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-4">
                        <div className="footer_inner_2">
                            <p>Asiera CLG<br />
                                3rd Floor, North Dock 2,<br />
                                93/94 North Wall Quay,<br />
                                Dublin 1, D01 V8Y6,<br />
                                Ireland.</p></div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="footer_keepwell_logo">
                            <img src={KeepwellMark} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <p className="copyright">© Copyright 2026</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
}